import { Component, OnInit, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { ValidationService } from 'src/app/services/validation.service';
import { BaseService } from 'src/app/services/base.service';
import { TranslateService } from '@ngx-translate/core';

  @Component({
    selector: 'personal-info',
    templateUrl: './personal-info.component.html'
  })
  export class PersonalInfoComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Input() isSocialID_Mandarory: boolean = null;
    @Input() relation;
    datepickers: any;
    israelyDisplay = false;
    isForChild= false;
    label_social_id="מספר תעודת זהות";
    placeholderSocialId;
    
    constructor ( private translate: TranslateService, public baseService: BaseService) { }

    ngOnInit(): void {
    
      this.form.addControl('social_id', new FormControl('',   this.isSocialID_Mandarory ? [Validators.required, ValidationService.IdValidator] :[ValidationService.IdValidator]));
      this.form.addControl('first_name', new FormControl('', [Validators.required, ValidationService.textHebrewValidator]));
      this.form.addControl('sex', new FormControl('1', [Validators.required]));
      this.form.addControl('first_name_eng', new FormControl('', [Validators.required, ValidationService.textEnglishValidator]));
      this.form.addControl('birth_date', new FormControl('',[ValidationService.DateRequired]));
      this.form.addControl('last_name', new FormControl('', [Validators.required, ValidationService.textHebrewValidator]));
      this.form.addControl('last_name_eng', new FormControl('', [Validators.required, ValidationService.textEnglishValidator]));
      this.form.addControl('returning_date', new FormControl('', [ValidationService.DateRequired]));
      this.datepickers = document.getElementsByClassName('datepicker');
      this.label_social_id = 'מספר תעודת זהות של ' + this.relation;   
      this.placeholderSocialId = this.isSocialID_Mandarory ? 'מספר תעודת זהות' : 'שדה חובה לישראלים בלבד';
      //this.EnDisAbleSocial_IDfield();
  }
      
    public get f() {
        return this.form.controls;  
    }
   
    checkIfExistsID() {
      let social_id = this.f.social_id as AbstractControl;
      let social_id_value = this.form.value.social_id;
      if (!social_id.errors && social_id_value != "")
      {
        this.baseService.checkIsExistsID(social_id_value).subscribe(res => {
           social_id.setErrors(ValidationService.CheckExists(social_id, res));                    
        });
      }      
    }

    ngOnChanges(changes: SimpleChanges) {
      const curr_change: SimpleChange = changes.isSocialID_Mandarory;
      
      if (curr_change && this.form.controls.social_id) {
        this.form.controls.social_id.setValidators(curr_change.currentValue == true ? 
          [Validators.required, ValidationService.IdValidator] : [ValidationService.IdValidator]);
        this.form.controls.social_id.updateValueAndValidity();

        //this.EnDisAbleSocial_IDfield();
      }        
    }

    // EnDisAbleSocial_IDfield () {
    //   if (this.isSocialID_Mandarory)
    //     this.form.controls.social_id.enable();
    //   else
    //     this.form.controls.social_id.disable();
    // }
  }